/**
 * <shipping-bar>: the free-shipping meter in the cart drawer (ATB redesign 2026-10). Markup:
 * snippets/shipping-bar.liquid. Styles: assets/atb-cart.css (.cd-ship).
 *
 * While the drawer is open, assets/cart-drawer.js patches the message and the bar width in place, and the CSS
 * transition animates the width. When the drawer is re-rendered from scratch (it was closed), this element is
 * new, so it animates from the last width it showed. lastKnownPct lives at module level for that reason.
 */
let lastKnownPct = null;

class ShippingBar extends HTMLElement {
  connectedCallback() {
    const fill = this.querySelector('[data-shipping-fill]');
    if (!fill) return;
    const target = parseFloat(fill.style.width) || 0;
    const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduced && lastKnownPct !== null && Math.abs(lastKnownPct - target) > 0.1 && typeof fill.animate === 'function') {
      fill.animate([{ width: `${lastKnownPct}%` }, { width: `${target}%` }], {
        duration: 600,
        easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
      });
    }
    lastKnownPct = target;
  }

  /* Called by cart-drawer.js after it patches the width in place. */
  remember(pct) {
    lastKnownPct = pct;
  }
}

if (!customElements.get('shipping-bar')) {
  customElements.define('shipping-bar', ShippingBar);
}
